"use strict";

var _slicedToArray = require("/Users/natebennett/Documents/Talus/Code/AdLib/adlib/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/Users/natebennett/Documents/Talus/Code/AdLib/adlib/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var CarouselDots_1 = __importDefault(require("./CarouselDots"));

var useCarouselTimers_1 = __importDefault(require("./useCarouselTimers"));

var buttons_1 = require("./buttons");

var Section = styled_components_1.default.section(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: 0 35px;\n"])));
var CarouselMain = styled_components_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var Page = styled_components_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  transition: 0ms;\n  transform: translate(0);\n"]))); // these styles are objects, instead of styled components,
// so that the divs they're applied to don't re-mount all
// the children each render cycle, which is inefficient
// and can cause a flicker when child components trigger
// effects.

var tempPageStyle = {
  position: 'absolute',
  top: 0,
  width: '100%'
};
var nextStyle = Object.assign(Object.assign({}, tempPageStyle), {
  left: 'calc(100% + 15px)'
});
var prevStyle = Object.assign(Object.assign({}, tempPageStyle), {
  right: 'calc(100% + 15px)'
});
var activeStyle = {
  position: 'relative',
  width: '100%'
};

var Carousel = function Carousel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$transition = _ref.transition,
      transition = _ref$transition === void 0 ? 250 : _ref$transition,
      _ref$buttonColor = _ref.buttonColor,
      buttonColor = _ref$buttonColor === void 0 ? '#316DA4' : _ref$buttonColor,
      _ref$disabledButtonCo = _ref.disabledButtonColor,
      disabledButtonColor = _ref$disabledButtonCo === void 0 ? '#EAEBED' : _ref$disabledButtonCo,
      _ref$dotColor = _ref.dotColor,
      dotColor = _ref$dotColor === void 0 ? buttonColor : _ref$dotColor,
      _ref$inactiveDotColor = _ref.inactiveDotColor,
      inactiveDotColor = _ref$inactiveDotColor === void 0 ? disabledButtonColor : _ref$inactiveDotColor;
  var pages = react_1.default.Children.toArray(children);

  var _ref2 = (0, react_1.useState)({
    activeIndex: 0
  }),
      _ref3 = _slicedToArray(_ref2, 2),
      state = _ref3[0],
      setState = _ref3[1];

  (0, useCarouselTimers_1.default)(transition, state, setState);
  var translate = '0';
  if (state.prevIndex !== undefined) translate = 'calc(100% + 15px)';
  if (state.nextIndex !== undefined) translate = 'calc(-100% - 15px)';
  return react_1.default.createElement(Section, {
    className: className
  }, react_1.default.createElement(CarouselDots_1.default, Object.assign({
    activeIndex: state.activeIndex,
    onClick: function onClick(_, index) {
      if (index === state.activeIndex) return;
      if (index < state.activeIndex) setState(function (prev) {
        return Object.assign(Object.assign({}, prev), {
          prevIndex: index
        });
      });else setState(function (prev) {
        return Object.assign(Object.assign({}, prev), {
          nextIndex: index
        });
      });
    }
  }, {
    pages: pages,
    dotColor: dotColor,
    inactiveDotColor: inactiveDotColor
  })), react_1.default.createElement(CarouselMain, null, react_1.default.createElement(Page, {
    style: {
      transform: "translate(".concat(translate, ")"),
      transition: "".concat(translate !== '0' ? transition + 'ms' : '0ms')
    }
  }, react_1.default.createElement("div", {
    key: state.prevIndex,
    style: Object.assign(Object.assign({}, prevStyle), {
      opacity: state.prevIndex !== undefined ? '1' : '0',
      transition: "".concat(transition, "ms")
    })
  }, state.prevIndex !== undefined && pages[state.prevIndex]), react_1.default.createElement("div", {
    key: state.activeIndex,
    style: Object.assign(Object.assign({}, activeStyle), {
      opacity: state.prevIndex !== undefined || state.nextIndex !== undefined ? '0' : '1',
      transition: "".concat(translate !== '0' ? transition + 'ms' : '0ms')
    })
  }, pages[state.activeIndex]), react_1.default.createElement("div", {
    key: state.nextIndex,
    style: Object.assign(Object.assign({}, nextStyle), {
      opacity: state.nextIndex !== undefined ? '1' : '0',
      transition: "".concat(transition, "ms")
    })
  }, state.nextIndex !== undefined && pages[state.nextIndex])), react_1.default.createElement(buttons_1.PrevButton, {
    color: buttonColor,
    disabledColor: disabledButtonColor,
    disabled: state.activeIndex === 0,
    onClick: function onClick() {
      return setState(function (prev) {
        return Object.assign(Object.assign({}, prev), {
          prevIndex: prev.activeIndex - 1
        });
      });
    }
  }), react_1.default.createElement(buttons_1.NextButton, {
    color: buttonColor,
    disabledColor: disabledButtonColor,
    disabled: state.activeIndex === pages.length - 1,
    onClick: function onClick() {
      return setState(function (prev) {
        return Object.assign(Object.assign({}, prev), {
          nextIndex: prev.activeIndex + 1
        });
      });
    }
  })));
};

exports.default = Carousel;